
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';

// import { isMobile, isTablet } from 'react-device-detect';

export const styles = (_theme) => ({
  root: {
    lineHeight: '24px',
    cursor: 'pointer',
    fontWeight: 400,
    '&:hover': {
      // background: isMobile || isTablet ? null : 'rgba(220,230,235, 0.5)',
      // transition: '.5s ease',
      // borderRadius: '3px',
    },
  },
  thinFont: {
    lineHeight: '20px',
    fontWeight: 400,
  },
});

class QTypography extends PureComponent {

  render() {
    const { thinFont, clickable, classes, className, ...other } = this.props;
    return (
      <Typography
        className={classNames(clickable ? classes.root : '', thinFont ? classes.thinFont : '', className)}
        classes={{
          root: className,
        }}
        {...other}
      />
    );
  }
}

QTypography.propTypes = {
  // values parent can pass in
  thinFont: PropTypes.bool,
  clickable: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  className: PropTypes.string,

  classes: PropTypes.object,
};

export default withStyles(styles)(QTypography);
